var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePlaceHolderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 9,
    fill: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8702 44.5149L19.8402 44.5449C19.4352 43.6599 19.1802 42.6549 19.0752 41.5449C19.1802 42.6399 19.4652 43.6299 19.8702 44.5149Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5007 31.5697C31.4723 31.5697 33.0707 29.9713 33.0707 27.9997C33.0707 26.028 31.4723 24.4297 29.5007 24.4297C27.529 24.4297 25.9307 26.028 25.9307 27.9997C25.9307 29.9713 27.529 31.5697 29.5007 31.5697Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2855 18.9961H27.7155C22.2555 18.9961 19.0005 22.2511 19.0005 27.7111V40.2811C19.0005 41.9161 19.2855 43.3411 19.8405 44.5411C21.1305 47.3911 23.8905 48.9961 27.7155 48.9961H40.2855C45.7455 48.9961 49.0005 45.7411 49.0005 40.2811V36.8461V27.7111C49.0005 22.2511 45.7455 18.9961 40.2855 18.9961ZM46.5555 34.7461C45.3855 33.7411 43.4955 33.7411 42.3255 34.7461L36.0855 40.1011C34.9155 41.1061 33.0255 41.1061 31.8555 40.1011L31.3455 39.6811C30.2805 38.7511 28.5855 38.6611 27.3855 39.4711L21.7755 43.2361C21.4455 42.3961 21.2505 41.4211 21.2505 40.2811V27.7111C21.2505 23.4811 23.4855 21.2461 27.7155 21.2461H40.2855C44.5155 21.2461 46.7505 23.4811 46.7505 27.7111V34.9111L46.5555 34.7461Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceHolderIcon);
export default __webpack_public_path__ + "static/media/imagePlaceHolderIcon.38435f67a4d7b0c68a36980f7eab62d8.svg";
export { ForwardRef as ReactComponent };